interface Result {
  label: string;
  value: string;
  unit: string;
  icon: string;
}

interface CaseResultsProps {
  results: Result[];
}

export default function CaseResults({ results }: CaseResultsProps) {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 to-emerald-600">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">项目成果</h2>
          <p className="text-lg text-white/90">通过技术创新为客户带来的实际价值</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {results.map((result, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 text-center hover:bg-white/20 transition-all"
            >
              <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${result.icon} text-2xl text-white`}></i>
              </div>
              <div className="text-5xl font-bold text-white mb-2">
                {result.value}
                <span className="text-2xl ml-1">{result.unit}</span>
              </div>
              <div className="text-white/90 font-medium">{result.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
